module.exports = __webpack_public_path__ + "images/content-custom.cb59521d12b3067ca85fec320bf40da3.svg";